import React from 'react';

export const MainNarrow = ({ children }: { children: React.ReactNode }) => {
    return <div id="mainnarrow">{children}</div>;
};
